import { render, staticRenderFns } from "./ApplianceNavigator.vue?vue&type=template&id=595df0a1"
import script from "./ApplianceNavigator.vue?vue&type=script&lang=js"
export * from "./ApplianceNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports